module.exports = __webpack_public_path__ + "static/media/instrument.567af450.svg";